import axios from 'axios';
import { API_CONFIG } from '../config/api.config';

export interface Notification {
  id: number;
  userId: number;
  type: string; // 'live_class', 'info', 'alert'
  message: string;
  relatedId?: string;
  isRead: boolean;
  createdAt: string;
}

export const notificationService = {
  
  getAll: async () => {
    const response = await axios.get(API_CONFIG.getApiUrl('/notifications'));
    return response.data; // { notifications: [], unreadCount: 0 }
  },

  getUnreadCount: async () => {
    const response = await axios.get(API_CONFIG.getApiUrl('/notifications/unread-count'));
    return response.data.count;
  },

  markAsRead: async (id: number) => {
    const response = await axios.put(API_CONFIG.getApiUrl(`/notifications/${id}/read`));
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await axios.put(API_CONFIG.getApiUrl('/notifications/read-all'));
    return response.data;
  },

  deleteNotification: async (id: number) => {
    const response = await axios.delete(API_CONFIG.getApiUrl(`/notifications/${id}`));
    return response.data;
  },

  // Helper pour créer une notif depuis un plugin front-end (ex: prof qui notifie)
  sendNotification: async (targetUserId: number, type: string, message: string, relatedId?: string) => {
      const response = await axios.post(API_CONFIG.getApiUrl('/notifications/internal/trigger'), {
          targetUserId, type, message, relatedId
      });
      return response.data;
  }
};
